import { render } from "./user.vue?vue&type=template&id=7a505dac&ts=true"
import script from "./user.vue?vue&type=script&lang=ts"
export * from "./user.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__